import { createAction, props, union } from '@ngrx/store';

export const setDismissed = createAction('[MilestoneActions] setDismissed', props<{ points: number }>());

const all = union({ setDismissed });
export type MilestonesActionsUnion = typeof all;
